import { axiosFactory, errorHandler } from "@/configs/axios";

const change_password = {
  api: (payload) => {
    return axiosFactory()
      .auth.put("api/accounts/v1/password/change/", payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        errorHandler(error);
      });
  },
};

export { change_password };
